/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  app.Filters.Total = app.Filters.Checkbox.extend({});
})();

}.call(window));